export const departments = {
	COSTING_DETAILS: { name: "Costing Details", key: "COSTING_DETAILS" },
	SPLIT_QTY: { name: "Split Qty", key: "SPLIT_QTY" },
};
